<ion-content>
  <app-empty *ngIf="layout === 'empty'; else main"></app-empty>
  <ng-template #main>
    <app-main></app-main>
  </ng-template>
</ion-content>
